import { useEffect, useState } from "react";
import { Button, Col, Flex, Form, Input, Menu, Row, Space } from "antd";
import { IconPrimary, Loading, Popup } from ".";
import { DeleteIcon } from "../assets";
import { FaGear } from "react-icons/fa6";
import IconSelector from "./IconSelector";
import { useForm } from "antd/es/form/Form";
import * as FaIcons from "react-icons/fa";
import { useAppDispatch, useAppSelector } from "../redux/hooks";
import {
  addProduct,
  deleteProduct,
  updateProduct,
} from "../redux/apiActions/productAction";
import { getProductState } from "../redux/store/getState";

const ProductManager = () => {
  const [form] = useForm();
  const [updateForm] = useForm();
  const dispatch = useAppDispatch();
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const Icon = (FaIcons as any)[selectedItem?.icon];

  const { products, loading } = useAppSelector(getProductState);

  useEffect(() => {
    updateForm.setFieldsValue(selectedItem);
  }, [selectedItem, updateForm]);

  return (
    <div className="choose_icon_container">
      <Popup
        openTrigger={
          <Flex
            align="middle"
            gap={10}
            className="choose_icon_item"
            style={{ paddingLeft: 8 }}
          >
            <h6 style={{ fontWeight: 400 }}>Manage Products</h6>
            <FaGear style={{ marginTop: 4 }} />
          </Flex>
        }
      >
        {(loading.addProduct ||
          loading.getProduct ||
          loading.deleteProduct) && <Loading />}
        <div className="choose_icon_heading">
          <h5>Products</h5>
        </div>
        <Row gutter={[20, 20]}>
          <Col span={12}>
            <div className="choose_icon_items_container">
              <div className="choose_icon_items">
                <Flex justify="center">
                  {!products.length ? <h5>No Products</h5> : null}
                </Flex>

                <Menu
                  style={{ border: "none" }}
                  selectedKeys={[selectedItem?.id]}
                  items={products.map((item: any) => {
                    const { id, name, icon } = item;
                    const Icon = (FaIcons as any)[icon];
                    return {
                      key: id,
                      icon: Icon ? <Icon /> : null,
                      label: name,
                      onClick: () => setSelectedItem(item),
                      style: { borderBottom: 0, width: "100%" },
                    };
                  })}
                />
              </div>
            </div>
          </Col>
          <Col span={12}>
            <Space direction="vertical">
              <Flex justify="center" style={{ marginBottom: 15 }}>
                {selectedItem?.icon && Icon ? (
                  <Icon color="white" size={48} />
                ) : null}
              </Flex>
              <Space direction="vertical">
                <Form
                  onFinish={(values) => {
                    if (selectedItem?.id) {
                      dispatch(
                        updateProduct({ ...values, id: selectedItem?.id })
                      );
                      form.resetFields();
                    }
                  }}
                  form={updateForm}
                >
                  <Form.Item name="name">
                    <Input placeholder="Name" />
                  </Form.Item>
                  <IconSelector
                    onSelect={(icon) => updateForm.setFieldsValue({ icon })}
                    openTrigger={
                      <Form.Item name="icon">
                        <Input placeholder="Search icon" readOnly />
                      </Form.Item>
                    }
                  />
                  <Space size="large">
                    <IconPrimary
                      onClick={() => {
                        dispatch(deleteProduct(selectedItem?.id));
                        updateForm.resetFields();
                        setSelectedItem(null);
                      }}
                    >
                      <DeleteIcon />
                    </IconPrimary>
                    <Button htmlType="submit" type="primary">
                      Update
                    </Button>
                  </Space>
                </Form>
              </Space>

              <h6 style={{ fontWeight: 400, marginTop: 10 }}>Add Product</h6>
              <Form
                onFinish={(values) => {
                  dispatch(addProduct(values));
                  form.resetFields();
                }}
                form={form}
              >
                <Form.Item name="name">
                  <Input placeholder="Name" />
                </Form.Item>

                <IconSelector
                  onSelect={(icon) => form.setFieldsValue({ icon })}
                  openTrigger={
                    <Form.Item name="icon">
                      <Input placeholder="Search icon" readOnly />
                    </Form.Item>
                  }
                />

                <Flex justify="end">
                  <Button type="primary" htmlType="submit">
                    Add
                  </Button>
                </Flex>
              </Form>
            </Space>
          </Col>
        </Row>
      </Popup>
    </div>
  );
};
export default ProductManager;
